export const CopyContant = async (textToCopy:string)=>{
    await navigator.clipboard.writeText(textToCopy)
}